import Vue from 'vue'
import ElementUI from 'element-ui'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import PendingApprovalHint from './components/common/PendingApprovalHint.vue'
import ApprovalGateCard from './components/common/ApprovalGateCard.vue'
import TableIndexColumn from './components/common/TableIndexColumn.vue'
import TableViewModeToggle from './components/common/TableViewModeToggle.vue'
import router from './router'
import './styles/index.css'
import './guides/styles.css'
import {initAdminTracking} from './services/tracker'
import {initVersionGuard} from './services/versionGuard'
import {installPermissionDirective} from './directives/permission'
import {displayRole, displaySource, displayStatus, displayType, normalizeUserMessage} from './utils/displayText'
import {installElementUiA11yLocalization} from './utils/elementUiA11y'
import {isTableViewFull} from './services/tableViewPreferences'

const SYSTEM_TITLE = '清宸云翼品牌系统'

// 本地多工作树并行开发时，用浏览器实际访问端口标识当前标签页来源。
function refreshDocumentTitle() {
    const port = window.location.port
    document.title = port ? `[${port}]${SYSTEM_TITLE}` : SYSTEM_TITLE
}

Vue.use(ElementUI, {
    size: 'small',
    // 显式锁定组件库中文文案，避免分页、日期和空态受运行环境语言影响。
    locale: zhCN,
})
installElementUiA11yLocalization()
installPermissionDirective(Vue)

// 模板中的状态、类型和来源统一走中文解析，避免各页面再次直接回显接口编码。
Vue.prototype.$displayStatus = displayStatus
Vue.prototype.$displayType = displayType
Vue.prototype.$displaySource = displaySource
Vue.prototype.$displayRole = displayRole

// 后台表格统一复用序号列，避免各页面重复实现跨页编号公式。
Vue.component(TableIndexColumn.name, TableIndexColumn)
Vue.component(PendingApprovalHint.name, PendingApprovalHint)
Vue.component(ApprovalGateCard.name, ApprovalGateCard)
Vue.component(TableViewModeToggle.name, TableViewModeToggle)
// 页面只负责标记完整视图的补充列，具体偏好读取与保存统一由共享服务处理。
Vue.prototype.$isFullTableView = isTableViewFull

const ElementTable = Vue.component('ElTable')
if (ElementTable && ElementTable.options && ElementTable.options.props && ElementTable.options.props.border) {
    // 统一后台表格默认边框；页面仍可通过显式传入 :border="false" 覆盖该默认值。
    ElementTable.options.props.border.default = true
}

Vue.config.productionTip = false

// Vue 2 会把模板点击事件返回的 Promise 异常交给 errorHandler；这里只兜底用户主动操作，
// 避免页面遗漏 catch 时表现为“点击后没有任何反应”。
Vue.config.errorHandler = (error, vm, info) => {
    if (String(info || '').includes('v-on handler')) {
        if (error === 'cancel' || error === 'close') return
        const backendMessage = error && error.response && error.response.data
            ? error.response.data.message
            : error && error.message
        Vue.prototype.$message.error(normalizeUserMessage(backendMessage, '操作失败，请稍后重试。'))
    }
    console.error(error)
}

refreshDocumentTitle()
initAdminTracking(router)
initVersionGuard(router)

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
